export const adminFilters = [];

export const inputFilters = [
  {
    name: "domains",
    label: "All Domains",
    storeValue: "domains",
    elasticSearchFilterField: "domain",
    displayText: "name",
    valueField: "id",
    isSearchBack: false,
    isMultipleSelect: true
  },
  {
    name: "programs",
    label: "All Shows",
    elasticSearchFilterField: "programs",
    displayText: "name",
    valueField: "urlHash",
    isSearchBack: true
  },
  {
    name: "episodes",
    label: "All Episodes",
    storeValue: "episodes",
    elasticSearchFilterField: "episode",
    displayText: "name",
    valueField: "value",
    isSearchBack: false
  },
  {
    name: "devices",
    label: "All Devices",
    storeValue: "devices",
    elasticSearchFilterField: "device",
    displayText: "name",
    valueField: "value",
    isSearchBack: false
  },
  {
    name: "modes",
    label: "All Modes",
    elasticSearchFilterField: "mode",
    displayText: "name",
    valueField: "value",
    isSearchBack: false
  }
];
